import React from 'react';
import { FormState, Form as FormStateForm } from 'react-formstate';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import WiredInput from '../components/WiredInput';
import { focusOnFirstInvalid, focusOnInput, populateFormErrors } from '../../utils/validation';
import ValidationMessage from '../components/ValidationMessage';
import T from '../components/T';
import Label from '../components/Label';

export default class PaymentForm extends React.Component {
  static contextTypes = {
    formatters: PropTypes.object
  };

  props: {
    price: number,
    isMonthlyDonation: boolean
  };

  isCompany = false

  buttonPaymentMethods = [
    { label: 'Tatra banka (Tatrapay)', value: '38409407-c4ec-4060-b4a1-4792f29335ad' },
    { label: 'Slovenská sporiteľňa (SporoPay)', value: 'c07e714c-74ed-4ac6-ab63-3898a73f1fa0' },
    { label: 'VUB banka (ePlatby)', value: 'f2e7956e-a3f6-4bff-9e18-2ab3096a5bed' },
    // { label: 'UniCredit (UniPlatba)', value: 'uniplatba' },
    // { label: 'Poštová banka (PoBaPay)', value: 'iterminal' },
  ];

  constructor(props) {
    super(props);

    this.formState = FormState.create(this);
    this.state = this.formState.injectModel(props.form);
  }

  componentDidUpdate() {
    // reflect form height
    const { parentForceRerender } = this.props;
    parentForceRerender();
  }

  componentWillMount() {
    const { isMonthlyDonation } = this.props;
    if (isMonthlyDonation) {
      const context = this.formState.createUnitOfWork();
      const fieldState = context.getFieldState('paymentMethod');

      if (fieldState.getValue() === 'button') {
        fieldState.setValue('card').validate();
        context.updateFormState();
      }
    }
  }

  componentDidMount() {
    focusOnInput(this, 'donorFirstName');
  }

  getCardValue(isMonthlyDonation) {
    return !isMonthlyDonation ? '1342d2af-a343-4e73-9f5a-7593b9978697' : 'b71ff7cf-39f7-40db-8a34-e1f30292c215';
  }

  getTransferValue(isMonthlyDonation) {
    return !isMonthlyDonation ? '3dcf55d1-6383-45b4-b098-dc588187b854' : 'f425f4af-74ce-4a9b-82d6-783c93b80f17';
  }

  onRadioChange = (name, value) => (e) => {
    if (e.target.tagName === 'INPUT') return;

    const context = this.formState.createUnitOfWork();
    const fieldState = context.getFieldState(name);
    fieldState.setValue(value).validate();

    if (name === 'paymentMethod' && value === 'button') {
      const firstButtonPaymentMethod = this.buttonPaymentMethods[0].value;
      context.set('buttonPaymentMethod', firstButtonPaymentMethod).validate();
    }

    context.updateFormState();
  };

  onAnonymousDonationLabelClick = (e) => {
    // event is fired twice, for checkbox and for label. Ignore one of them.
    if (e.target.tagName === 'INPUT') return;

    const context = this.formState.createUnitOfWork();
    const fieldState = context.getFieldState('isAnonymousDonation');
    fieldState.setValue(+fieldState.getValue('isAnonymousDonation') ^ 1).validate();
    context.updateFormState();
  };

  onIsCompanyLabelClick = (e) => {
    // event is fired twice, for checkbox and for label. Ignore one of them.
    if (e.target.tagName === 'INPUT') return;

    const context = this.formState.createUnitOfWork();
    const fieldState = context.getFieldState('isCompany');
    fieldState.setValue(+fieldState.getValue('isCompany') ^ 1).validate();
    this.isCompany = (!this.isCompany);
    console.log(this.isCompany)
    context.updateFormState();
  };

  onRequestConfirmationLabelClick = (e) => {
    // event is fired twice, for checkbox and for label. Ignore one of them.
    if (e.target.tagName === 'INPUT') return;

    const context = this.formState.createUnitOfWork();
    const fieldState = context.getFieldState('requestConfirmation');
    fieldState.setValue(+fieldState.getValue('requestConfirmation') ^ 1).validate();
    context.updateFormState();
  };

  onAffirmDataProcessing = ({ target: { tagName } }) => {
    // event is fired twice, for checkbox and for label. Ignore one of them.
    if (tagName === 'INPUT') return;

    const context = this.formState.createUnitOfWork();
    const fieldState = context.getFieldState('affirmDataProcessing');
    fieldState.setValue(+fieldState.getValue('affirmDataProcessing') ^ 1).validate();
    context.updateFormState();
  };

  onInputChange = ({ target: { name, value } }) => {
    const context = this.formState.createUnitOfWork();
    context.set(name, value).validate();
    context.updateFormState();
  };

  onSubmit = (e) => {
    const { onSubmit } = this.props;
    e.preventDefault();

    const model = this.formState.createUnitOfWork().createModel();
    if (model) {
      onSubmit(e, model);
    } else {
      focusOnFirstInvalid(this.formState, this);
    }
  };

  onCancel = (e) => {
    e.preventDefault();
    const { onCancel } = this.props;

    const { model } = this.formState.createUnitOfWork().createModelResult();
    onCancel(e, model);
  };

  render() {
    const { formDisabled, price, isMonthlyDonation } = this.props;
    const { formatters } = this.context;
    const errors = populateFormErrors(this.formState);

    return (
      <section className="donation">
        <div className="c-floating__head">
          <a href="#" className="text-icon" onClick={this.onCancel}>
            <i className="icon-arrow-back text-icon__icon" />
            <span className="text-icon__text">Naspäť</span>
          </a>
          <span />
        </div>
        <FormStateForm formState={this.formState} className="c-floating__body" onSubmit={this.onSubmit}>
          <fieldset disabled={formDisabled}>
            <div className="donation__cfloating-padding">
              <div className="donation__contact-fields">
                <label className="c-input__wrapper">
                  <span className="c-input__label">
                    Meno
                  </span>

                  <span className={classNames(
                    'c-input__border', { 'c-input__border--error': errors.donorFirstName }
                  )}>
                    <WiredInput
                      name="donorFirstName"
                      className="c-input"
                      onChange={this.onInputChange}
                      validator={v => v
                        .required().msg('donation.form.errors.donorFirstName.required')}
                    />
                  </span>
                  <ValidationMessage msg={errors.donorFirstName} />
                </label>

                <label className="c-input__wrapper">
                  <span className="c-input__label">
                    Priezvisko
                  </span>

                  <span className={classNames(
                    'c-input__border', { 'c-input__border--error': errors.donorLastName }
                  )}>
                    <WiredInput
                      name="donorLastName"
                      className="c-input"
                      onChange={this.onInputChange}
                      validator={v => v
                        .required().msg('donation.form.errors.donorLastName.required')}
                    />
                  </span>
                  <ValidationMessage msg={errors.donorLastName} />
                </label>

                <label className="c-input__wrapper">
                  <span className="c-input__label">
                    E-mailová adresa
                  </span>

                  <span className={classNames(
                    'c-input__border', { 'c-input__border--error': errors.donorEmail }
                  )}>
                    <WiredInput
                      name="donorEmail"
                      type="email"
                      className="c-input"
                      onChange={this.onInputChange}
                      validator={v => v
                        .required().msg('donation.form.errors.donorEmail.required')
                        .email().msg('donation.form.errors.donorEmail.required')}
                    />
                  </span>
                  <ValidationMessage msg={errors.donorEmail} />
                </label>
              </div>

              <div className="donation__company-fields">
                <Label className="c-checkbox" onClick={this.onIsCompanyLabelClick}>
                  <WiredInput
                    type="checkbox"
                    name="isCompany"
                    defaultValue={0}
                    className="c-checkbox__input"
                  />
                  <i className="icon-checkbox c-checkbox__icon" />
                  <span className="c-checkbox__text">
                    <T msg="donation.labels.isCompany" />
                  </span>
                </Label>

                <div className={this.isCompany ? 'show': 'hide'}>
                  <label className="c-input__wrapper">
                    <span className="c-input__label">
                      Názov PO
                    </span>
                    <span className="c-input__border">
                      <WiredInput
                        name="businessName"
                        type="text"
                        className="c-input"
                        onChange={this.onInputChange}
                      />
                    </span>
                  </label>

                  <label className="c-input__wrapper">
                    <span className="c-input__label">
                      Adresa
                    </span>
                    <span className="c-input__border">
                      <WiredInput
                        name="businessAddress"
                        type="text"
                        className="c-input"
                        onChange={this.onInputChange}
                      />
                    </span>
                  </label>

                  <label className="c-input__wrapper">
                    <span className="c-input__label">
                      IČO
                    </span>
                    <span className="c-input__border">
                      <WiredInput
                        name="businessId"
                        type="text"
                        className="c-input"
                        onChange={this.onInputChange}
                      />
                    </span>
                  </label>

                  <label className="c-input__wrapper">
                    <span className="c-input__label">
                      DIČ
                    </span>
                    <span className="c-input__border">
                      <WiredInput
                        name="taxId"
                        type="text"
                        className="c-input"
                        onChange={this.onInputChange}
                      />
                    </span>
                  </label>

                  <label className="c-input__wrapper">
                    <span className="c-input__label">
                      IČ DPH
                    </span>
                    <span className="c-input__border">
                      <WiredInput
                        name="vatId"
                        type="text"
                        className="c-input"
                        onChange={this.onInputChange}
                      />
                    </span>
                  </label>

                  <u><p className="c-para donation__tos"><a href="https://darujme.sk/pre-darcov-firmy/">Darovanie Právnických osôb cez DARUJME.sk</a></p></u>

                  <Label className="c-checkbox" onClick={this.onRequestConfirmationLabelClick}>
                    <WiredInput
                      type="checkbox"
                      name="requestConfirmation"
                      defaultValue={0}
                      className="c-checkbox__input"
                    />
                    <i className="icon-checkbox c-checkbox__icon" />
                    <span className="c-checkbox__text">
                    <T msg="donation.labels.requestConfirmation" />
                  </span>
                  </Label>

                </div>
              </div>

              <Label className="c-checkbox" onClick={this.onAnonymousDonationLabelClick}>
                <WiredInput
                  type="checkbox"
                  name="isAnonymousDonation"
                  defaultValue={0}
                  className="c-checkbox__input"
                />
                <i className="icon-checkbox c-checkbox__icon" />
                <span className="c-checkbox__text">
                  <T msg="donation.labels.isAnonymousDonation" />
                </span>
              </Label>

              <div className="donation__payment-fields">
                <p className="c-input__label">Platobná metóda</p>
                <div className="expander--1-4" />

                <Label className="c-checkbox" onClick={this.onRadioChange('paymentMethod', this.getCardValue(isMonthlyDonation))}>
                  <WiredInput
                    name="paymentMethod"
                    type="radio"
                    value={this.getCardValue(isMonthlyDonation)}
                    className="c-checkbox__input"
                    defaultValue={this.getCardValue(isMonthlyDonation)}
                    validator={v => v
                      .required().msg('donation.form.errors.paymentMethod.required')}
                  />
                  <i className="icon-radio c-checkbox__icon" />
                  <span className="c-checkbox__text">
                    <span className="text-icon">
                      <span className="text-icon__text">Platba kartou</span>
                      <span className="text-icon__icon">
                        <img src="/assets/images/cards.png" alt="" height="16" />
                      </span>
                    </span>
                  </span>
                </Label>

                {!isMonthlyDonation && (
                  <div>
                    <Label className="c-checkbox" onClick={this.onRadioChange('paymentMethod', 'button')}>
                      <WiredInput
                        name="paymentMethod"
                        type="radio"
                        value="button"
                        className="c-checkbox__input"
                        validator={v => v.required().msg('Zvolte platobnu metodu')}
                      />
                      <i className="icon-radio c-checkbox__icon" />
                      <span className="c-checkbox__text">Platba bankovými tlačítkami</span>
                    </Label>
                    <div
                      className="donation__payment-fields donation__payment-fields--indent"
                      style={{ display:
                        this.formState.getFieldState('paymentMethod').getValue() === 'button' ? 'block' : 'none'
                      }}
                    >
                      <div className="expander--1-4" />
                      {this.buttonPaymentMethods.map(({ value, label }) => (
                        <Label key={value}
                          className="c-checkbox"
                          onClick={this.onRadioChange('buttonPaymentMethod', value)}
                        >
                          <WiredInput
                            name="buttonPaymentMethod"
                            type="radio"
                            value={value}
                            className="c-checkbox__input"
                          />
                          <i className="icon-radio c-checkbox__icon" />
                          <span className="c-checkbox__text">{label}</span>
                        </Label>
                      ))}
                      <div className="expander--1-4" />
                    </div>
                  </div>
                )}

                <Label className="c-checkbox" onClick={this.onRadioChange('paymentMethod', this.getTransferValue(isMonthlyDonation))}>
                  <WiredInput
                    name="paymentMethod"
                    type="radio"
                    value={this.getTransferValue(isMonthlyDonation)}
                    className="c-checkbox__input"
                    validator={v => v
                      .required().msg('donation.form.errors.paymentMethod.required')}
                  />
                  <i className="icon-radio c-checkbox__icon" />
                  <span className="c-checkbox__text">Bankovým prevodom</span>
                </Label>

                <ValidationMessage msg={errors.payment} />
                {errors.payment && <div className="expander--1-2" />}
              </div>

              <div className="donation__payment-fields">
                <Label className="c-checkbox c-checkbox--no-margin" onClick={this.onAffirmDataProcessing}>
                  <WiredInput
                    type="checkbox"
                    name="affirmDataProcessing"
                    defaultValue={0}
                    className="c-checkbox__input"
                    validator={v => v
                      .equals('1').msg('donation.form.errors.affirmDataProcessing.equals')
                    }
                  />
                  <i className="icon-checkbox c-checkbox__icon" />
                  <span className="c-checkbox__text">
                    <T msg="donation.labels.affirmThat" />
                    <a href="https://darujme.sk/pravidla-ochrany-osobnych-udajov/" className="u-underline" target="_blank">
                      <T msg="donation.labels.beenInformedDataProcessing" />
                    </a>
                  </span>
                </Label>
                <ValidationMessage msg={errors.affirmDataProcessing} />
              </div>

              <div className="expander--1-2" />

              <button type="submit" className="c-button c-button--primary donation__submit">
                <span className="c-button__content">
                  <span className="text-icon">
                    <span className="text-icon__text">Darujte {formatters.formatCurrency(price, '€', 2)} {!!isMonthlyDonation && 'mesačne'}</span>
                    <i className="icon-arrow-forward text-icon__icon" />
                  </span>
                </span>
              </button>

              <p className="c-para donation__tos">Darovaním súhlasíte s <a href="https://darujme.sk/pravidla-a-podmienky/" className="u-underline" target="_blank">Podmienkami&nbsp;používania</a></p>
            </div>
          </fieldset>
        </FormStateForm>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/donation/PaymentForm.js